import { Grid, Paper, Tab, Tabs } from "@mui/material";
import TabLabel from "components/pages/transmissions/tabs/label/TabLabel";
import useNonCompliantPatientTabs from "./hooks/useNonCompliantPatientTab";

const NonCompliantPatientTabs = ({
  selectedTab,
  tabStyles,
  setSelectedTab,
}) => {
  const { tabs, liveCallTodoTasksCount, onTabChange } =
    useNonCompliantPatientTabs(tabStyles, setSelectedTab);

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          {selectedTab && (
            <Paper
              square
              elevation={0}
              style={{
                position: "relative",
                top: "1px",
                zIndex: 1000,
                backgroundColor: "transparent",
              }}
            >
              <Tabs
                onChange={(_event, value) => {
                  onTabChange(value);
                }}
                value={selectedTab}
                indicatorColor="secondary"
                TabIndicatorProps={{
                  style: { top: 0, borderBottom: "none" },
                }}
                textColor="secondary"
              >
                {tabs.map(({ label, value, style }, index) => (
                  <Tab
                    key={index}
                    disabled={false}
                    style={style}
                    value={value}
                    sx={{ fullWidth: true }}
                    label={
                      <TabLabel
                        label={label}
                        count={
                          label === "Live Call Tasks"
                            ? liveCallTodoTasksCount
                            : 0
                        }
                      />
                    }
                  />
                ))}
              </Tabs>
            </Paper>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default NonCompliantPatientTabs;
